/*
 * Native Possum — np-form.js
 * Behaviour for every form[data-np-form] (NP enquiry pages on Shopify's contact
 * form: page.np-contact, page.np-corporate-gifting). Styles: assets/np-form.css.
 *
 * Opt-in by markup, nothing page-specific in here:
 *   [data-np-form-error]       Shopify's error message after a refused send: the page
 *                              focuses it and puts back everything the shopper typed
 *                              (kept for this tab only, sessionStorage) — WCAG 3.3.7.
 *   [data-np-form-sent]        the "sent" message (rendered by Liquid instead of the
 *                              fields): the page scrolls to the top and focuses it.
 *   .np-form-hp input          honeypot: if a bot fills it, the form doesn't send.
 *   input[type=email]          checked on send; the message goes in the element named
 *                              by its aria-describedby that has .np-form-message.
 *   select[data-np-helpers]    shows the [data-np-helper="<chosen value>"] note in the
 *                              same form, hides the rest (notes sit in a live region).
 *   input[data-np-order-number] tidied to #NP-1234 on leave/send; a note says when it
 *                              doesn't look like ours. Never blocks sending.
 *                              UPDATE ORDER_DIGITS when order numbers pass #NP-9999.
 */
(function () {
  'use strict';

  var ORDER_DIGITS = 4;
  var ORDER_NOT_OURS = 'That doesn’t look like a Native Possum order number — ours start with #NP-. You can still send your message.';
  var EMAIL_INVALID = 'Please enter a valid email address (e.g. name@example.com)';

  function messageFor(input) {
    var ids = (input.getAttribute('aria-describedby') || '').split(/\s+/);
    for (var i = 0; i < ids.length; i++) {
      var el = ids[i] && document.getElementById(ids[i]);
      if (el && el.classList.contains('np-form-message')) return el;
    }
    return null;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(value);
  }

  function normalizeOrderNumber(raw) {
    var cleaned = raw.replace(/[\s#\-_]/g, '').toUpperCase();
    if (cleaned === '') return null;
    var match = cleaned.match(new RegExp('^(?:NP)?(\\d{' + ORDER_DIGITS + '})$'));
    return match ? '#NP-' + match[1] : null;
  }

  function setupHelpers(form) {
    form.querySelectorAll('select[data-np-helpers]').forEach(function (select) {
      var helpers = form.querySelectorAll('[data-np-helper]');
      select.addEventListener('change', function () {
        helpers.forEach(function (helper) {
          helper.hidden = helper.getAttribute('data-np-helper') !== select.value;
        });
      });
    });
  }

  function setupOrderNumber(form) {
    var input = form.querySelector('input[data-np-order-number]');
    if (!input) return function () {};
    var note = messageFor(input);

    function check() {
      var raw = input.value.trim();
      if (raw === '') {
        if (note) note.textContent = '';
        return;
      }
      var normalized = normalizeOrderNumber(raw);
      if (normalized) {
        input.value = normalized;
        if (note) note.textContent = '';
      } else if (note) {
        note.textContent = ORDER_NOT_OURS;
      }
    }

    input.addEventListener('blur', check);
    input.addEventListener('input', function () {
      if (note) note.textContent = '';
    });
    return check;
  }

  // What was typed, kept per page for this tab so a refused send never loses it
  var KEEP = 'np-form:' + location.pathname;
  function store(action, value) {
    try {
      if (action === 'get') return JSON.parse(sessionStorage.getItem(KEEP) || 'null');
      if (action === 'set') sessionStorage.setItem(KEEP, JSON.stringify(value));
      else sessionStorage.removeItem(KEEP);
    } catch (e) { return null; }
    return null;
  }

  function typedFields(form) {
    return Array.prototype.filter.call(form.elements, function (el) {
      return el.name && !el.closest('.np-form-hp') &&
        /^(text|email|tel|number|textarea|select-one)$/.test(el.type);
    });
  }

  function setupForm(form) {
    var sent = form.querySelector('[data-np-form-sent]');
    if (sent) {
      store('clear');
      window.scrollTo({ top: 0, behavior: window.npMotion.scroll() });
      sent.focus();
      return;
    }

    var refused = form.querySelector('[data-np-form-error]');
    var kept = refused ? store('get') : null;
    if (!refused) store('clear');

    setupHelpers(form);
    var checkOrderNumber = setupOrderNumber(form);
    if (kept) {
      typedFields(form).forEach(function (el) {
        if (kept[el.name] == null || el.value) return;
        el.value = kept[el.name];
        if (el.tagName === 'SELECT') el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    var honeypot = form.querySelector('.np-form-hp input');
    var email = form.querySelector('input[type="email"]');
    var emailMessage = email && messageFor(email);

    if (email) {
      email.addEventListener('input', function () {
        if (emailMessage) emailMessage.textContent = '';
        email.removeAttribute('aria-invalid');
      });
    }

    form.addEventListener('submit', function (e) {
      if (honeypot && honeypot.value !== '') {
        e.preventDefault();
        return;
      }

      checkOrderNumber();

      if (email && !isValidEmail(email.value)) {
        e.preventDefault();
        if (emailMessage) emailMessage.textContent = EMAIL_INVALID;
        email.setAttribute('aria-invalid', 'true');
        email.scrollIntoView({ behavior: window.npMotion.scroll(), block: 'center' });
        setTimeout(function () { email.focus(); }, 300);
        return;
      }

      var values = {};
      typedFields(form).forEach(function (el) { values[el.name] = el.value; });
      store('set', values);
    });

    if (refused) {
      refused.scrollIntoView({ block: 'center' });
      refused.focus();
    }
  }

  document.querySelectorAll('form[data-np-form]').forEach(setupForm);
})();
